import moment from "moment";

export const returnMissingZeroes = (count) => {
    let str = '';

    for (let i = 0; i < count; i++) {
        str += '0';
    }

    return str;
}

export const getColorByQCFlag = (flag, getQcFlagEntryByFlag) => {
    const actualQcFlag = getQcFlagEntryByFlag(flag);

    if (actualQcFlag)
        return actualQcFlag.color;
    else
        return 'inherit';
}

export const returnFullQcFlag = (qc_flag) => {
    if (qc_flag.length !== 4) {
        const missing = 4 - qc_flag.length;
        return returnMissingZeroes(missing) + qc_flag;
    } else {
        return qc_flag;
    }
}

export const returnBgColorByQcFlag = (qcFlag, getQcFlagEntryByFlag) => {
    const flag = returnFullQcFlag(`${qcFlag}`);
    const priorityFlag = +flag[0] ? flag[0] : +flag[1] ? flag[1] : +flag[2] ? flag[2] : flag[3];

    return getColorByQCFlag(priorityFlag, getQcFlagEntryByFlag);
}

export const returnColorByQcFlag = (qcFlag) => {
    const flag = returnFullQcFlag(`${qcFlag}`);
    const priorityFlag = +flag[0] ? flag[0] : +flag[1] ? flag[1] : +flag[2] ? flag[2] : flag[3];

    return +priorityFlag ? 'white' : 'black';
}

export const generalizedRecursiveFunction = async ({fun, relevantParameters, date_from, date_to, updateProgress, separate}) => {
    // const differenceInWeeks = moment(date_to).diff(moment(date_from), 'weeks');
    //
    // if(differenceInWeeks >= 4 || separate) {
    //     const oneWeekLater = moment(date_from).add(1, 'week');
    //     const oneWeekData = await generalizedRecursiveFunction({fun, relevantParameters, date_from, date_to: oneWeekLater, updateProgress});
    //
    //     if(oneWeekLater.isBefore(moment(date_to))) {
    //         const otherData = await generalizedRecursiveFunction({fun, relevantParameters, date_from: oneWeekLater, date_to, separate: true, updateProgress});
    //
    //         return [...oneWeekData, ...otherData];
    //     } else {
    //         return oneWeekData;
    //     }
    // } else {
    //     const lengthExceedingParameterKey = Object.keys(relevantParameters).find(key => relevantParameters[key].length > 4);
    //
    //     if(lengthExceedingParameterKey) {
    //         const oneChunkOfRelevantParameters = {};
    //         const otherChunksOfRelevantParameters = {};
    //
    //         Object.keys(relevantParameters).forEach(key => oneChunkOfRelevantParameters[key] = key === lengthExceedingParameterKey ?  relevantParameters[key].slice(0, 4) : relevantParameters[key]);
    //         Object.keys(relevantParameters).forEach(key => otherChunksOfRelevantParameters[key] = key === lengthExceedingParameterKey ?  relevantParameters[key].slice(4, relevantParameters[key].length) : relevantParameters[key]);
    //
    //         const oneChunk = await generalizedRecursiveFunction({fun, date_from, date_to, relevantParameters: oneChunkOfRelevantParameters, updateProgress});
    //
    //         const otherChunks = await generalizedRecursiveFunction({fun, date_from, date_to, relevantParameters: otherChunksOfRelevantParameters, updateProgress});
    //
    //         return [...oneChunk, ...otherChunks];
    //     } else {
            const parameters = {};

            Object.keys(relevantParameters).forEach(key => parameters[key] = relevantParameters[key]);

            parameters['date_from'] = date_from;
            parameters['date_to'] = date_to;

            const response = await fun(parameters);

            // if(updateProgress)
            //     updateProgress();

            return response;
        // }
    // }
};

export const random_rgba = () => {
    const o = Math.round, r = Math.random, s = 255;
    return 'rgb(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ')';
};



// WEBPACK FOOTER //
// ./src/utils.js